import { mainUrl } from './../../../global-variables';
import { TextHelper } from './../../../utils/text-helper';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss'],
})
export class DeeplinkComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private textHelper: TextHelper
  ) {
    let url = this.route.snapshot.paramMap.get('url');
    const id = this.route.snapshot.queryParamMap.get('id');
    url = 'deeplink/' + url + (id ? '?id=' + id : '');
    url = this.textHelper.replaceDeeplinkToCorrectUrls(url);
    if (url) {
      this.router.navigate([url]);
    } else {
      this.router.navigate([mainUrl]);
    }
  }

  ngOnInit() {}
}
